import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { cn } from '@/utils/cn';
import { AppSidebar } from './AppSidebar';
import { useAuth } from '@/hooks/useAuth';
import type { UserInfo, ProcessingStatus } from '@/types/sidebar.types';

interface DashboardLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const mockUser: UserInfo = {
  name: 'Doug',
  email: 'doug@claimsiq.com',
  role: 'Administrator',
  company: 'ClaimsIQ Demo',
  plan: 'PROFESSIONAL',
};

const mockProcessingStatus: ProcessingStatus = {
  activeJobs: 0,
  completedToday: 3,
  availableCredits: 2847,
  isProcessing: false,
};

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children, className }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const sidebarUser: UserInfo = user
    ? {
        name: user.name,
        email: user.email,
        role: user.role,
        company: user.company,
        plan: user.plan,
      }
    : mockUser;

  return (
    <div className="min-h-screen bg-gray-50">
      <AppSidebar
        currentPath={location.pathname}
        onNavigate={(path) => navigate(path)}
        user={sidebarUser}
        processingStatus={mockProcessingStatus}
        onLogout={logout}
      />

      {/* Main content area */}
      <main
        className={cn(
          'transition-all duration-300 min-h-screen',
          'ml-0 lg:ml-72',
          className
        )}
      >
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;